// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import Badge from '@material-ui/core/Badge';
import NotificationsRoundedIcon from '@material-ui/icons/NotificationsRounded';
import FPIconButton from 'UI/components/atoms/FPIconButton';
import { topBarIconSize } from 'UI/constants/dimensions';

import { useBadgeStyles } from './NotificationButton.styled';

type NotificationButtonProps = {
  onDrawerOpen: () => any
};

export const NotificationButton = ({ onDrawerOpen }: NotificationButtonProps) => {
  const classes = useBadgeStyles();

  const totalUnread = useSelector(({ notification }) => notification.domain.totalUnread);

  return (
    <Badge
      badgeContent={totalUnread || null}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      className={classes.badge}
      color="primary"
      overlap="circle"
    >
      <FPIconButton
        icon={NotificationsRoundedIcon}
        iconProps={{ size: topBarIconSize }}
        onClick={onDrawerOpen}
        tooltipProps={{ title: 'Notifications ' }}
      />
    </Badge>
  );
};
